<template>
  <div class="form-group">
    <div class="form-buttons">
      <button class="bttn pull-right" @click.prevent="$emit('accepted')">
        APPLY
      </button>
      <button class="bttn pull-right" @click.prevent="$emit('cancelled')">
        CANCEL
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "form-buttons"
};
</script>

<style lang="scss" scoped>
.bttn {
  font-family: Montserrat !important;
  width: fit-content;
  font-size: 12px;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #efefef !important;
  color: black;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-family: "Montserrat" !important;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.bttn:focus {
  outline: none !important;
}
.bttn:hover {
  transform: scale(1.05);
}
</style>
